<template>
  <app-main>
    <app-header slot="header" color="is-default" :is_display_down="is_display_down"></app-header>
    <div class="trust">
      <h2 class="content-title">
        <span class="border"></span>
        <span>
          13周年回顾视频
        </span>
      </h2>
      <div class="video">
        <video-play :video="videos[0].video" :cover="videos[0].cover"></video-play>

      </div>
      <p class="center">
        从PC时代的B2C翡翠电商创新者，<br>
        到移动互联网时代的翡翠电商开拓者，<br>
        再到直播时代的珠宝玉石新零售开创者。<br>
        翡翠王朝一直在砥砺前行，<br>
        因为我们只做一件事——<br>
        “以客户开心为头等大事”！
      </p>
      <h2 class="content-title">
        <span class="border"></span>
        <span>
          翡翠王朝荣获改革开放40周年珠宝行业双重大奖
        </span>
      </h2>
      <div class="image">
        <img src="../assets/images/trust/content_image_1.png" alt="">
      </div>
      <p>
        “感谢中保协及有关部门对翡翠王朝的肯定，这是对公司13年诚信坚守的肯定，也是全国翠友与我们携手创造的荣誉，我们将以此为勉励，继续匠心坚守，更好地服务社会、服务全国网友。” 翡翠王朝创始人杨牧仁表示。
      </p>
      <!--      <h2 class="content-title">
              <span class="border"></span>
              <span>
                签约太平洋保险，承诺假一赔500万
              </span>
            </h2>
            <div class="image">
              <img src="../assets/images/trust/content_image_2.png" alt="">
            </div>
            <p>“让所有珠宝玉石消费者不买假、不买错，构建一个客观公正的信赖体系”，是我们翡翠王朝的矢质追求。自成立以来始终坚持立足源头，为广大翠友提供一手精品货源和源头精品宝玉石，已为超过百万的顾客提供过优质服务，累计售100多万件翡翠，未发现一件假货。</p>
            --><h2 class="content-title">
      <span class="border"></span>
      <span>
          一路相伴·见证发展
        </span>
    </h2>
      <div class="video">
        <video-play :video="videos[1].video" :cover="videos[1].cover"></video-play>

      </div>
      <h2 class="content-title">
        <span class="border"></span>
        <span>
          信赖者
        </span>
      </h2>
      <div class="image">
        <a href="http://apph5.jaadee.com/appv2/articles?categoryId=39">
        <img src="../assets/images/trust/content_image_3.png" alt="">
        </a>
      </div>
      <p>讲述每一位信赖者和翡翠王朝之间的故事，你们的信任是我们不断前行的动力，你们的信赖是对我们最高的赞誉。</p>
      <div class="company">
        云南翡翠王朝网络科技有限公司©版权所有
      </div>
    </div>

  </app-main>
</template>

<script>
  import AppMain from './layouts/Main';
  import AppHeader from './layouts/Header';
  import cover1 from "../assets/images/trust/video_cover_1.png";
  import cover2 from "../assets/images/trust/video_cover_2.png";
  import VideoPlay from "../components/VideoPlay";
  import { setStatusTextColor } from "../RNApp";
  export default {
    name: 'trust',
    components: {
      AppMain,AppHeader,VideoPlay
    },
    data() {
      return {
        is_display_down:false,
        videos:[
          {
            video: "https://res.jaadee.net/active/video/jaadee13.mp4",
            cover: cover1
          },
          {
            video: "https://res.jaadee.net/active/video/6.mp4",
            cover: cover2
          }
        ]

      }
    },
    computed: {
    },
    mounted() {
      this.$nextTick(() => {
        this.setStatus();
      });
    },
    methods:{
      setStatus() {
        if (this.$route.query.inApp == 6) {
          setStatusTextColor("black");
        }
      }
    }
  }
</script>

<style lang="scss" scoped >
  .trust{
    background-color: rgba(255,255,255,1);
    padding: 0 0.16rem 0 0.16rem;
    .content-title{
      display: flex;
      align-items: center;
      text-align: left;
      font-size:0.2133rem;
      font-weight:500;
      color:rgba(51,51,51,1);
      padding-top: 0.26rem;
      .border{
        width: 0.04rem;
        height: 0.2133rem;
        background-color: rgba(46, 153, 82, 1);
        border-radius:0.0233rem;
        margin-right: 0.1rem;
      }
    }
    .video{
      display: flex;
      position: relative;
      padding: 0.13rem 0;
      video{
        display: flex;
      }
      .play{
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .button{
          width: 0.67rem;
          height: 0.67rem;
        }
      }
    }
    .image{
      padding: 0.13rem 0;
    }
    p{
      font-size:0.1867rem;
      color:rgba(51,51,51,1);
      line-height:0.3333rem;
      text-align: left;
    }
    p.center{
      text-align: center;
    }
    .company{
      padding: 0.27rem 0;
      font-size:0.16rem;
      color:rgba(153,153,153,1);
    }

  }
</style>
